import Form from 'erxes-ui/lib/components/form/Form';

export default Form;
